(function () {
 function syncView() {
  const container = document.getElementById("ProductGridContainer");
  const grid = document.querySelector(".collection-grid");
  if (!container || !grid) return;

  const saved = localStorage.getItem("collectionView") || "grid";
  container.classList.toggle("list-view", saved === "list"); // <-- was: grid.classList.toggle(...)

  const toggle = document.querySelector(".collection-view-toggle");
  if (toggle) {
    toggle.querySelectorAll(".view-btn").forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.view === saved);
    });
  }
}

  function initCollectionView() {
    const anchor = document.getElementById("CollectionViewToggle");
    if (!anchor) return;

    if (!anchor.querySelector(".collection-view-toggle")) {
      const toggle = document.createElement("div");
      toggle.className = "collection-view-toggle";
      toggle.innerHTML = `
        <button class="view-btn" data-view="grid" aria-label="Grid View">
          <svg width="18" height="18" viewBox="0 0 24 24">
            <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
            <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
          </svg>
        </button>
        <button class="view-btn" data-view="list" aria-label="List View">
          <svg width="18" height="18" viewBox="0 0 24 24">
            <rect x="4" y="5" width="16" height="2"/><rect x="4" y="11" width="16" height="2"/>
            <rect x="4" y="17" width="16" height="2"/>
          </svg>
        </button>
      `;
      anchor.appendChild(toggle);

      toggle.querySelectorAll(".view-btn").forEach((btn) => {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          localStorage.setItem("collectionView", this.dataset.view);
          syncView();
        });
      });
    }

    syncView();
  }

  document.addEventListener("DOMContentLoaded", initCollectionView);
  document.addEventListener("shopify:section:load", initCollectionView);
  document.addEventListener("shopify:section:reorder", initCollectionView);

  const gridTarget = document.getElementById("ProductGridContainer");
  if (gridTarget) {
    let debounceTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncView, 50); // just re-sync class, don't rebuild toggle
    });
    observer.observe(gridTarget, { childList: true, subtree: true });
  }
})();